import { useAuthStore } from 'store/useAuthStore';
import { useAppStore } from 'store/useAppStore';

// Custom hook that provides access to all stores
export const useStore = () => {
    const auth = useAuthStore();
    const app = useAppStore();

    return {
        auth,
        app,
        // Convenience methods
        isAuthenticated: !!auth.user && !!auth.token,
        user: auth.user,
        token: auth.token,
        logout: auth.logout,
        login: auth.login,
        theme: app.theme,
        setTheme: app.setTheme,
        sidebarCollapsed: app.sidebarCollapsed,
        toggleSidebar: app.toggleSidebar,
        permissions: app.permissions,
        setPermissions: app.setPermissions,
        menus: app.menus,
        setMenus: app.setMenus,
        userName: app.userName,
        setUserName: app.setUserName,
    };
};

// Individual store hooks for more specific use cases
export const useAuth = () => useAuthStore();
export const useApp = () => useAppStore(); 